import React, { useState } from 'react'
import { FiChevronLeft, FiChevronRight, FiMoreHorizontal } from 'react-icons/fi'

function getPageNumbers(currentPage, totalPages) {
  if (totalPages <= 7) return Array.from({ length: totalPages }, (_, i) => i + 1)
  if (currentPage <= 3) return [1, 2, 3, 4, '...', totalPages]
  if (currentPage >= totalPages - 2)
    return [1, '...', totalPages - 3, totalPages - 2, totalPages - 1, totalPages]
  return [1, '...', currentPage - 1, currentPage, currentPage + 1, '...', totalPages]
}

const GlassBtn = ({ onClick, disabled, active, children, wide }) => {
  const [hovered, setHovered] = useState(false)
  const on = !disabled && (hovered || active)

  return (
    <button
      onClick={onClick}
      disabled={disabled}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '6px',
        height: '36px',
        minWidth: wide ? 'auto' : '36px',
        padding: wide ? '0 14px' : '0',
        borderRadius: '9px',
        border: active
          ? '1px solid rgba(250,204,21,0.7)'
          : hovered && !disabled
          ? '1px solid rgba(250,204,21,0.35)'
          : '1px solid rgba(255,255,255,0.06)',
        background: active
          ? 'linear-gradient(135deg, rgba(250,204,21,0.22), rgba(250,204,21,0.08))'
          : hovered && !disabled
          ? 'rgba(250,204,21,0.07)'
          : 'rgba(8,8,14,0.72)',
        backdropFilter: 'blur(12px)',
        color: active ? '#facc15' : hovered && !disabled ? '#facc15' : '#4b5563',
        fontWeight: 700,
        fontSize: '12px',
        letterSpacing: active || hovered ? '0.06em' : '0.04em',
        textTransform: 'uppercase',
        fontFamily: 'Space Grotesk, sans-serif',
        boxShadow: active
          ? '0 0 18px rgba(250,204,21,0.25), inset 0 1px 0 rgba(250,204,21,0.12)'
          : hovered && !disabled
          ? '0 0 10px rgba(250,204,21,0.1)'
          : 'inset 0 1px 0 rgba(255,255,255,0.04)',
        transform: on && !active ? 'translateY(-2px)' : 'translateY(0)',
        opacity: disabled ? 0.35 : 1,
        transition: 'all 0.22s cubic-bezier(0.34,1.56,0.64,1)',
        cursor: disabled ? 'not-allowed' : 'pointer',
      }}
    >
      {children}
    </button>
  )
}

export function Pagination({ currentPage, totalPages, onPageChange }) {
  const pages = getPageNumbers(currentPage, totalPages)

  const go = (page) => {
    onPageChange(page)
    const outlet = document.querySelector('.outlet-scroll')
    if (outlet) outlet.scrollTo({ top: 0, behavior: 'smooth' })
  }

  return (
    <nav
      style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '6px', marginTop: '40px', flexWrap: 'wrap' }}
      role='navigation'
      aria-label='pagination'
    >
      <GlassBtn onClick={() => go(currentPage - 1)} disabled={currentPage === 1} wide>
        <FiChevronLeft size={14} />
        Prev
      </GlassBtn>

      {pages.map((page, idx) =>
        page === '...' ? (
          <span key={`e-${idx}`} style={{ color: '#374151', display: 'flex', alignItems: 'center', padding: '0 4px' }}>
            <FiMoreHorizontal size={14} />
          </span>
        ) : (
          <GlassBtn key={page} onClick={() => go(page)} active={currentPage === page}>
            {page}
          </GlassBtn>
        )
      )}

      <GlassBtn onClick={() => go(currentPage + 1)} disabled={currentPage === totalPages} wide>
        Next
        <FiChevronRight size={14} />
      </GlassBtn>
    </nav>
  )
}
